import React, { useState, useEffect } from 'react';
import './scss/style.scss';
import './css/style.css';
import './css/header.css';
import './css/searchbar.css';
import './css/login.css';
import './css/custom.css';
//import './config/bootstrap.scss';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Container } from 'react-bootstrap';


/** pages */
import Login from './pages/login/index';
import LoginStandard from './pages/login/loginStandard';
import Recover from './pages/login/recover';
import Reset from './pages/login/reset';
import NotFound from './pages/not_found';
import NotFoundNotLogged from './pages/not_found_not_logged';
import License from './pages/license';
import Privacy from './pages/privacy';
import Cookie from './pages/cookie';
import Help from './pages/help';
import Home from './pages/index';
import Categories from './pages/categories';
import Category from './pages/category';
import Course from './pages/course';
import Event from './pages/event';
import Episode from './pages/episode';
import Continue from './pages/continue';
import Events from './pages/events';
import Convegni from './pages/convegni';
import Profile from './pages/profile';
import Association from './pages/associations';
import AssociationDetail from './pages/association';
import Search from './pages/search';
import Publication from './pages/publications';
import PublicationDetail from './pages/publicationDetail';
import Blog from './pages/blog/index';
import Entry from './pages/entry/index';
import Courses from './pages/courses';
import Materie from './pages/materie';
import Certificato from './pages/certificate/index';
import ZoomLive from './pages/zoom';



/** core & components */
import { LanguageProvider } from './core/language-provider';
import { LoginManager } from './core/login-manager';
import HeaderBlock from './components/BodyElements/HeaderBlock';
import FooterBlock from './components/BodyElements/FooterBlock';
import ConnectionStatus from './components/BodyElements/ConnectionStatus';
import NlPage from './config/nl_pages/AutoLogin/index'; //not-logged page



import { Helmet } from "react-helmet";
import { settings } from './config/settings';




function App() {

    library.add(fas)

    const [ isLogged, setIsLogged ] = useState(null);
    const [ language, setLanguage ] = useState('ita');


    useEffect(() => {
        async function init() {
            var response = await LoginManager.checkLogin()
            console.log('checkLogin', response)
            setIsLogged(response)
        }

        init()
        detectSidChange()
    }, []);

    async function detectSidChange() {
        var sessionId = LoginManager.registerChangeSid(async function () {
            var response = await LoginManager.checkLogin()
            console.log('CheckLogin after sid changed', response)
            setIsLogged(response)
        })
        console.log('--- SESSION ID ' + sessionId + ' ---')
    }


    useEffect(() => {
        LanguageProvider.setCurrentLanguage(language)
    }, [language]);
    


    if (isLogged === null) {
        return (
            <>
                <p>Loading...</p>
            </>
        )
    }
    else if (isLogged === false) {
        return (
            <Router basename={'/'} >
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{settings.title}</title>
                    <meta name="description" content="React application" />
                </Helmet>
                <div id='app-container'>
                    <Routes>
                        <Route exact path='/' element={<Login />} /> {/* default page */}
                        <Route exact path='/login_standard' element={<LoginStandard />} /> {/* default page */}
                        <Route exact path='/recover' element={<Recover />} />
                        <Route exact path='/reset' element={<Reset />} />
                        <Route path='/license' element={<License />} />
                        <Route path="*" element={<NotFoundNotLogged />} /> {/* 404 page */}
                        <Route path="/nl_page/:page" element={<NlPage />} />

                    </Routes>
                </div>
                <ToastContainer 
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light" 
                />
            </Router>
        )
    }
    else {
        return (
            <Router basename={'/'}>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{settings.title}</title>
                    <meta name="description" content="React application" />
                </Helmet>
                <Container fluid id="main-container" className='p-0'>
                    <HeaderBlock />
                    <div id='app-container'>
                        <Routes>
                            <Route path="*" element={<NotFound />} /> {/* 404 page */}
                            <Route exact path='/' element={<Home />} /> {/* default page */}
                            <Route path='/license' element={<License />} />
                            <Route path='/privacy' element={<Privacy />} />
                            <Route path='/cookie' element={<Cookie />} />
                            
                            <Route path='/help' element={<Help />} />
                            <Route path='/categories' element={<Categories />} />
                            <Route path="/category/:k" element={<Category />} />
                            <Route path="/corsi/:k" element={<Course />} />
                            <Route path="/associati/:k" element={<AssociationDetail />} />
                            <Route path="/pubblicazioni/:k" element={<PublicationDetail />} />
                            <Route path="/eventi/:k" element={<Event />} />
                            <Route path="/episodi/:k" element={<Episode />} />
                            <Route path="/zoom/:k" element={<ZoomLive />} />
                            <Route path='/continua' element={<Continue />} />
                            <Route path='/corsi' element={<Courses />} />
                            <Route path='/ricerca' element={<Search />} />
                            <Route path='/convegni' element={<Convegni />} />
                            <Route path='/eventi' element={<Events />} />
                            <Route path='/materie' element={<Materie />} />
                            <Route path='/profilo' element={<Profile />} />
                            <Route path='/pubblicazioni' element={<Publication />} />
                            <Route path='/associati' element={<Association />} />
                            <Route path="/certificate/:k" element={<Certificato />} />
                            <Route path="/nl_page/:page" element={<NlPage />} />


                            <Route path="/blog/:p" element={<Blog />} />
                            <Route path="/entry/:k" element={<Entry />} />
                        </Routes>
                    </div>
                    <FooterBlock />
                    <ToastContainer 
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light" 
                    />
                </Container>
            </Router>
        );
    }
    
}

export default App;